import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Text from "../../../utils/Custom/text";
import CommonForm from "../../../utils/commonComponent/commonForm";
import { CancelButton, SaveAndUpdate, } from "../../../utils/Custom/Button";
import { fetchByTable, fetchQuery } from "../../../utils/commonComponent/fetched";
import axiosWithToken from "../../../utils/commonComponent/axiosTokenConfig";
import { BASE_URL } from "../../../global";
import { getPermissions } from "../rbac/hasAccess";
import { validateRequiredFields } from "../../../utils/commonComponent/errorAlert";
import { designationOptions } from "../employeeMaster/employeeConstants";

const EditJobDescription = (props) => {
  const params = useParams();
  const permissions = getPermissions(props.moduleId);
  const navigate = useNavigate();
  const [inputStates, setInputStates] = React.useState({});

  const inputFields = [
    {
      type: "Autocomplete",
      label: "Designation *",
      stateKey: "designation",
      options: designationOptions.sort((a, b) => a.name.localeCompare(b.name)),
      valueKey: "name",
      getOptionLabelKey: "name",
    },
    { type: "TextField", label: "Grade *", stateKey: "grade" },
    { type: "emptySpace", label: "", stateKey: "" },
    { type: "emptySpace", label: "", stateKey: "" },
    { type: "Textarea1", label: "Duties *", stateKey: "duties" },
    { type: "Textarea1", label: "Authorities *", stateKey: "authorities" },
  ];

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
  };

  const fetchHolidayDetails = async () => {
    try {
      const [jobDescription] = await fetchQuery(
        `SELECT * FROM jobDescriptionMaster WHERE id = ${params.id}`
      );
      setInputStates(jobDescription);
    } catch (error) {
      console.error("Error fetching Job Description data:", error);
    }
  };

  const onSubmit = async () => {
    const fieldsToValidate = [
      { value: inputStates.designation, label: "Designation is required" },
      { value: inputStates.grade, label: "Grade is required" },
      { value: inputStates.duties, label: "Duties are required" },
      { value: inputStates.authorities, label: "Authorities are required" },
    ];

    if (!validateRequiredFields(fieldsToValidate)) {
      return;
    }

    try {
      const url = BASE_URL + `jobDescriptionMaster`;
      params.id !== "0"
        ? await axiosWithToken.patch(url + `/${params.id}`, inputStates)
        : await axiosWithToken.post(url, inputStates);

      toast.success(
        params.id !== "0"
          ? "Job Description Updated Successfully!"
          : "Job Description Created Successfully!"
      );
      if (params.id == 0) {
        setTimeout(() => navigate("/master/jobDescription"), 1000);
      } else {
        setTimeout(() => window.location.reload(), 1000);
      }
    } catch (error) {
      console.error("Submission failed:", error);
    }
  };

  useEffect(() => {
    if (params.id != 0) fetchHolidayDetails();
  }, [params]);

  return (
    <div>
      <Text variant="h3" bold className="text-blue-600">
        {params.id == 0 ? "Create New Job Description" : `Update Job Description `}
      </Text>
      <br />
      <CommonForm
        inputStates={inputStates}
        updateInputObject={updateInputObject}
        inputFields={inputFields}
      />
      <br />
      <div className="flex gap-10 mt-5 justify-end ">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        />
        {(permissions.save || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-add-outline"
            label={params.id == 0 ? "Save" : "Update"}
            onClick={onSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default EditJobDescription;
